export const NOMBRE_PLAN = { gratuito: "Plan Gratuito", trimestral: "Plan Trimestral", anual: "Plan Anual", pro: "Plan Pro" };
export const NOMBRE_CORTO = { trimestral: "Trimestral", anual: "Anual", pro: "Pro" };

const PLAN_MINIMO = { contratos: "anual", portal: "pro", leads: "pro", marca_blanca: "pro", secretaria: "pro" };

export const minimo = (funcion) => PLAN_MINIMO[funcion] || "trimestral";
export const tiene = (user, funcion) => Array.isArray(user?.funciones) && user.funciones.includes(funcion);
